module.exports = __webpack_public_path__ + "static/img/banner-finance-01.a6d5317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-finance-01.jpg
// module id = /HUs
// module chunks = 100